export default {
    name: "guide",
    title: "[deprecated] Guide",
    icon: require("./content-icon.svg"),
    category: "other",
    deprecated: true
}